var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c('v-container',[(_vm.user)?_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('user-form',_vm._b({attrs:{"loading":_vm.loading},on:{"change":_vm.change,"submit":_vm.submit}},'user-form',_vm.user,false))],1)],1):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }